<template>
  <component :is="mappedComponent" v-if="mappedComponent" :item="item" />
  <div v-else>
    Could not map <b>{{ item.fields.type }}</b>
  </div>
</template>

<script setup lang="ts">
import type GlobalComponents from '../../.nuxt/components';
import type { ITechnicalComponent } from '~/lib/ContentfulService';

type Components = typeof GlobalComponents;

interface Props {
  item: ITechnicalComponent;
}

const props = defineProps<Props>();

type ComponentType = NonNullable<ITechnicalComponent['fields']['type']>;

const componentMap: Partial<Record<ComponentType, keyof Components>> = {
  searchSection: 'LibSearchSection',
  tool: 'LibExternalTool',
  testCameraRequestForm: 'LibTestCameraForm',
  documentCenter: 'LibDownloadCenter',
  softwareCenter: 'LibSoftwareCenter'
};

const mappedComponent = computed(() =>
  props.item.fields.type ? componentMap[props.item.fields.type] : null
);
</script>
